import React from "react";
import AOS from "aos"; // Import AOS for animations
import "aos/dist/aos.css"; // Import AOS CSS
import { FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";

const ContactInfo = () => {
  

  return (
    <section className="py-10 bg-gray-50" id="contact">
      <div className="container mx-auto px-4">
        <h2
          className="text-center text-[#3A636C] font-semibold text-4xl p-8"
          data-aos="fade-up"
        >
          Contact <span className="text-textColor">Us</span>
        </h2>
        <p className="text-center text-gray-600 mb-8" data-aos="fade-up">
          We’d love to hear from you! Reach out for any inquiries or support.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Contact Details */}
          <div
            className="bg-white rounded-lg shadow-lg p-6"
            data-aos="fade-right"
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7974.975113293302!2d30.054501999999996!3d-1.9585350000000001!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19dca5cca28709c5%3A0x766f3424bac88c24!2sKN%2020%20Ave%2C%20Kigali!5e0!3m2!1sen!2srw!4v1725274977164!5m2!1sen!2srw"
              style={{
                width: "100%",
                allowFullScreen: "",
                loading: "lazy",
                referrerPolicy: "no-referrer-when-downgrade",
              }}
              className="xl:h-[70%] h-[45%]"
            ></iframe>

            <div className="xl:flex grid xl:space-x-10 space-y-2 mt-4 ">
              <div>
                <h3 className="text-xl font-semibold text-textColor mb-4">
                  Contact Details
                </h3>
                <ul className="space-y-[1px]">
                  <li className="flex items-center">
                    <span className="material-icons text-[#3A636C] mr-2">
                      phone:
                    </span>
                    <span className="text-gray-800">(+250) 798-434-426</span>
                  </li>
                  <li className="flex items-center">
                    <span className="material-icons text-[#3A636C] mr-2">
                      email:
                    </span>
                    <span className="text-gray-800">grandshoprw@gmail.com</span>
                  </li>
                  <li className="flex items-center">
                    <span className="material-icons text-[#3A636C] mr-2">
                      location_on:
                    </span>
                    <span className="text-gray-800">Rwanda, Kigali</span>
                  </li>
                </ul>
              </div>

              <div className="h-20" style={{ marginTop: "40px" }}>
                {/* Social Media Links */}
                <div className="text-start w-full" data-aos="fade-in">
                  <h3 className="text-xl font-semibold text-textColor mb-4">
                    Follow Us
                  </h3>
                  <div className="flex justify-start space-x-4">
                    <a
                      href="https://twitter.com/your_profile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaTwitter
                        style={{ fontSize: "24px", color: "#3A636C" }}
                      />
                    </a>
                    <a
                      href="https://linkedin.com/in/your_profile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin
                        style={{ fontSize: "24px", color: "#3A636C" }}
                      />
                    </a>
                    <a
                      href="https://instagram.com/your_profile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram
                        style={{ fontSize: "24px", color: "#3A636C" }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div
            className="bg-white rounded-lg shadow-lg p-6"
            data-aos="fade-left"
          >
            <h3 className="text-xl text-textColor font-semibold mb-4">
              Get in Touch
            </h3>
            <form>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1" htmlFor="name">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="w-full p-2 border border-gray-300 rounded hover:border-blue-500 focus:outline-none focus:ring focus:ring-blue-300"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1" htmlFor="email">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full p-2 border border-gray-300 rounded hover:border-blue-500 focus:outline-none focus:ring focus:ring-blue-300"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1" htmlFor="message">
                  Message
                </label>
                <textarea
                  id="message"
                  className="w-full p-2 border border-gray-300 rounded hover:border-[#3A636C] focus:outline-none focus:ring focus:ring-blue-300"
                  rows="4"
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full bg-[#3A636C] text-white font-bold py-2 rounded hover:bg-white transition duration-300"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
